import { render, staticRenderFns } from "./TransportationsStatusTab.vue?vue&type=template&id=291cdbbf&scoped=true&"
import script from "./TransportationsStatusTab.vue?vue&type=script&lang=js&"
export * from "./TransportationsStatusTab.vue?vue&type=script&lang=js&"
import style0 from "./TransportationsStatusTab.vue?vue&type=style&index=0&id=291cdbbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291cdbbf",
  null
  
)

export default component.exports